import React from 'react';
import { Link } from 'react-router-dom';

const reasons = [
  { icon: '🏆', title: '25+ Years Experience', desc: 'Proven track record since 1999 across diverse industries.' },
  { icon: '🌍', title: 'Global Presence', desc: 'Offices in USA and India serving clients in 15+ countries.' },
  { icon: '🏅', title: 'ISO 9001:2000 Certified', desc: 'Quality management systems certified to international standards.' },
  { icon: '🏛️', title: 'GSA Contract Holder', desc: 'Authorized to provide services to US government agencies.' },
  { icon: '📊', title: 'INC 500 Ranked #213', desc: 'Recognized among the fastest-growing private companies.' },
  { icon: '💬', title: '24/7 Support', desc: 'Round-the-clock support across time zones.' },
  { icon: '💰', title: 'Cost Effective', desc: 'Competitive pricing with no compromise on quality.' },
  { icon: '🚀', title: 'Fast Delivery', desc: 'Agile methodology ensuring on-time project delivery.' },
];

const WhyEGB = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Why Choose EGB?</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>What sets us apart from the rest</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {reasons.map((r, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 p-4 text-center">
                <div style={{ fontSize: 40 }} className="mb-3">{r.icon}</div>
                <h6 className="fw-bold">{r.title}</h6>
                <p className="text-muted small mb-0">{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5">
          <Link to="/contact" className="btn btn-primary btn-lg px-5">Work With Us →</Link>
        </div>
      </div>
    </section>
  </>
);

export default WhyEGB;
